import React, {Component} from "react";

import AliceCarousel from 'react-alice-carousel';
import LocationModule from "./LocationModule";
import ProductModule from "./ProductModule";
import SpacesModule from "./SpacesModule";
import EquipmentModule from "./EquipmentModule";
import ScheduleModule from "./ScheduleModule";

const Modules = () => {

    let items = [
        <LocationModule key="location" />,
        <ProductModule key="product" />,
        //<SpacesModule key="space" />,
        //<EquipmentModule key="equip" />,
        //<ScheduleModule key="schedule" />,
    ]

    return   (
        <div className="modules" >
            <AliceCarousel items={items} autoWidth={true} disableDotsControls={true} />
        </div>
    )

}

export default Modules;
